<div class="container">
  <input type="text" inputmode="numeric" pattern="[0-9]*" [ngClass]="{error: hasError}" [(ngModel)]="value" [size]="size" [maxLength]="size" (keydown)="keyDown($event)" #el>
  <span>{{label}}</span>
</div>
